export const AN_FONT =
  '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif';
export const AN_MONO =
  '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace';

// The palette, as hex, for each theme. Components use AN_COLORS (CSS
// variables, so they follow the theme without re-rendering); only code that
// cannot read CSS -- a canvas chart -- uses these, through useAnTheme().
export const AN_LIGHT = {
  ink: "#0B0D12",
  ink2: "#1A1D25",
  ink3: "#3A4150",
  muted: "#6B7280",
  line: "#E6E8EC",
  line2: "#EEF0F3",
  surface: "#FFFFFF",
  elevated: "#FFFFFF",
  bg: "#F7F8FA",
  bgWarm: "#FAFAF7",
  tint: "#F2F4FA",
  hover: "#F3F4F6",
  primary: "#2B3FE8",
  primaryD: "#1E2CC9",
  primaryL: "#E9ECFD",
  success: "#0F8F5D",
  danger: "#C8361C",
  warn: "#A36A0A",
  // Status tints: background, border, text.
  successBg: "#E7F6EF",
  successBd: "#C9ECDA",
  successFg: "#0F7A50",
  warnBg: "#FEF3E0",
  warnBd: "#F6DCB3",
  warnFg: "#8A5A00",
  dangerBg: "#FDECE7",
  dangerBd: "#F6CFC4",
  dangerFg: "#9A2B12",
  infoBg: "#EEF2FF",
  infoBd: "#D5DDFB",
  infoFg: "#2B3F98",
};

export const AN_DARK = {
  // Matches the AuthNull Authenticator app's dark theme (lib/theme/tokens.dart,
  // AppColors.dark). Translucent app colours are flattened onto the app's
  // background so antd and MUI get plain hex values.
  ink: "#EDF0F5",
  ink2: "#C4C9D3",
  ink3: "#9096A2",
  muted: "#6E7482",
  line: "#262A33",
  line2: "#1B1E26",
  surface: "#14161C",
  elevated: "#1B1E26",
  bg: "#0A0B0E",
  bgWarm: "#0A0B0E",
  tint: "#111319",
  hover: "#20242E",
  primary: "#3E6BFF",
  primaryD: "#9BB0FF",
  primaryL: "#111830",
  success: "#2ED573",
  danger: "#FF5A52",
  warn: "#FDB022",
  successBg: "#0F271C",
  successBd: "#14442A",
  successFg: "#2ED573",
  warnBg: "#2C2211",
  warnBd: "#4E3914",
  warnFg: "#FDB022",
  dangerBg: "#271416",
  dangerBd: "#4F2121",
  dangerFg: "#FF7A73",
  infoBg: "#111830",
  infoBd: "#192651",
  infoFg: "#9BB0FF",
};

export const AN_COLORS = Object.fromEntries(Object.keys(AN_LIGHT).map((k) => [k, `var(--an-${k})`]));

// A colour (hex or CSS variable) at `percent` opacity. Use instead of
// appending a hex alpha ("#2B3FE822"), which does not work on a variable.
export const anAlpha = (color, percent) => `color-mix(in srgb, ${color} ${percent}%, transparent)`;
